import { Component } from '@angular/core';

@Component({
  selector: 'app-pw-thanks-page',
  templateUrl: './pw-thanks-page.component.html',
  styleUrls: ['./pw-thanks-page.component.scss']
})
export class PwThanksPageComponent {

}
